import React from "react";
import { Bar } from "react-chartjs-2";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, ChartDataLabels);

const corTexto = "#01054C";

const buildOptions = (formatter) => ({
  responsive: true,
  maintainAspectRatio: false,
  layout: { padding: { top: 8 } },
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: (ctx) => ` ${formatter(ctx.raw)}`,
      },
    },
    datalabels: {
      anchor: "end",
      align: "start",
      rotation: -90,
      color: "#fff",
      font: { size: 12, weight: "bold" },
      formatter,
      offset: 6,
    },
  },
  scales: {
    x: {
      grid: { display: false },
      border: { display: false },
      ticks: { font: { size: 11, weight: "600" }, color: corTexto },
    },
    y: {
      display: false,
      beginAtZero: true,
    },
  },
});

const formatarValor = (v) =>
  v == null ? "" : new Intl.NumberFormat("pt-BR").format(v);

const formatarPct = (v) => (v == null ? "" : `${v}%`);



const Super4ValorChart = ({ title, titleColor = corTexto, labels = [], data = [], colors = [] }) => {
  const chartData = {
    labels,
    datasets: [
      {
        data,
        backgroundColor: colors,
         borderRadius: 10,
        barPercentage: 0.45,
        categoryPercentage: 0.8,
      },
    ],
  };

  return (
    <div className="rounded-xl bg-white p-5" >
      <h3 className="mb-4 text-lg font-bold" style={{ color: titleColor }}>
        {title}
      </h3>
      <div style={{ height: 260 }}>
        <Bar data={chartData} options={buildOptions(formatarValor)} />
      </div>
    </div>
  );
};



const Super4PercentualChart = ({ title, titleColor = corTexto, labels = [], data = [], colors = [] }) => {
  const chartData = {
    labels,
    datasets: [
      {
        data,
        backgroundColor: colors,
        borderRadius: 10,
        barPercentage: 0.45,
        categoryPercentage: 0.8,
      },
    ],
  };

  return (
    <div className="rounded-xl bg-white p-5" >
      <h3 className="mb-4 text-lg font-bold" style={{ color: titleColor }}>
        {title}
      </h3>
      <div style={{ height: 260 }}>
        <Bar data={chartData} options={buildOptions(formatarPct)} />
      </div>
    </div>
  );
};

export { Super4ValorChart, Super4PercentualChart };
